import { nsApi } from 'boot/axios'
import colors from 'quasar/src/utils/colors.js';

export default {
  namespaced: true,

  state: {
    theme: null,
    leftDrawer: true,
    searchMenu: false,
  },

  actions: {
    async init({ commit, state, rootState }, force = false) {
      if (!state.theme || force) {
        const { piva } = rootState.tenant
        const { data } = await nsApi.post('theme', { piva })
        commit('update', data)
      }

      // configurazione colori
      if (state.theme === 'Audiosoft') {
        colors.setBrand('primary', '#007177')
        colors.setBrand('secondary', '#009199')
      } else {
        colors.setBrand('primary', '#007EC2')
        colors.setBrand('secondary', '#00a6ff')
      }
    },
  },

  mutations: {
    update(state, theme) {
      state.theme = theme
    },
    toggleLeftDrawer(state, value = null) {
      state.leftDrawer = value || !state.leftDrawer
    },
    toggleSearchMenu(state, value = null) {
      state.searchMenu = value || !state.searchMenu
    },
  },
}
